

export type PasswordParameters = {
    guidsCount: number,
    hyphens: boolean,
    braces: boolean
}

import { defineComponent, reactive } from "vue";
import { Guid } from 'guid-typescript';
import store from "@/store";
export default defineComponent({    
    name: 'GuidPanel',
    data() {
        return {
            guidParams: {
                guidsCount: 1,
                hyphens: true
            } as PasswordParameters,
            guids: [] as Array<string>,
            loading: false,
            window: {
                width: 0,
                height: 0
            },
            styleObject: reactive({
                width: '600px'
            })
        }
    },
    created() {
        this.window = store.getters['window/windowSize']
    },
    watch: { 
        window: {
            handler(newVal) {
                if (newVal.width < 650 && newVal.width > 300) {
                    this.styleObject.width = (newVal.width - 50) + 'px'
                } else {
                    if (this.styleObject.width !== '600px') {
                        this.styleObject.width = '600px'
                    }
                }               
            },
            deep: true
         }
    },
    methods: {
        generateGuid() {
            this.guids = []
            for (let i = 0; i < this.guidParams.guidsCount; i++) {
                let guid = "";
                if (this.guidParams.braces === true) {
                    guid += "{";
                }
                guid += Guid.create().toString();                

                if (this.guidParams.hyphens === false) {
                    guid = guid.replaceAll("-", "");
                }                

                if (this.guidParams.braces === true) {
                    guid += "}";
                }      
                this.guids.push(guid);              
            }
        },        
        checkGuidsCount() {
            const value = Number(this.guidParams.guidsCount)
            if (Number.isInteger(value)) {
                if (value < 1) {
                    this.guidParams.guidsCount = 1
                } else if (value > 20) {
                    this.guidParams.guidsCount = 20
                }
            } else {
                this.guidParams.guidsCount = 1
            }
        }
    }
})
